import type { ScreenType } from '../types/screens';

export const SCREEN_PATHS: Record<ScreenType, string> = {
  main: '/',
  'emblem-step-up': '/emblem-step-up',
  loading: '/loading',
  'auto-return': '/auto-return',
  'camera-access': '/camera-access',
  'camera-setup': '/camera-setup',
  'desktop-waiting': '/desktop-waiting',
  success: '/success',
  failure: '/failure',
  'id-request': '/id-request',
  'id-capture': '/id-capture',
  'id-review': '/id-review',
  'id-processing': '/id-processing',
  'selfie-retry': '/selfie-retry',
  recovery: '/recovery',
  'return-to-desktop': '/return-to-desktop',
};

export const PATH_TO_SCREEN: Record<string, ScreenType> = Object.entries(
  SCREEN_PATHS
).reduce(
  (acc, [screen, path]) => ({ ...acc, [path]: screen as ScreenType }),
  {}
);
